import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICalculatorState } from '../../types';

interface ISetRedirectUrlPayloadAction {
  url: string;
}

interface IOpenAuthorizationModalPayloadAction {
  redirectUrl: string;
}

export const initialState: ICalculatorState = {
  authorizationModal: {
    isOpen: false,
    redirectUrl: null,
  },
  user: {
    isAuthorized: false,
  },
  entityId: 0,
  pageType: 'newBuilding',
  initialFormState: {
    objectCost: 1000000,
    loanTermYears: 30,
    downPayment: 500000,
  },
  defaultRedirectUrl: '',
};

export const calculatorSlice = createSlice({
  initialState,
  name: 'calculator',
  reducers: {
    openAuthorizationModal: (state, action: PayloadAction<IOpenAuthorizationModalPayloadAction>) => {
      state.authorizationModal.isOpen = true;
      state.authorizationModal.redirectUrl = action.payload.redirectUrl;
    },
    closeAuthorizationModal: state => {
      state.authorizationModal.isOpen = false;
      state.authorizationModal.redirectUrl = null;
    },
    setRedirectUrl: (state, action: PayloadAction<ISetRedirectUrlPayloadAction>) => {
      state.defaultRedirectUrl = action.payload.url;
    },
  },
});

export const { openAuthorizationModal, closeAuthorizationModal, setRedirectUrl } = calculatorSlice.actions;
